<template>
  <a-modal
    :visible="true"
    width="510px"
    :body-style="bodyStyle"
    :mask-closable="false"
    centered
    :footer="null"
    :keyboard="false"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img class="image__delete" src="@/app/users/assets/profiles/delete.png" alt="delete" />
      <p class="text__alert">Ingresa código de verificación</p>
    </div>
    <div class="container__info">
      <p class="text">
        Se ha enviado un código de verificación al correo electrónico “{{ emailToDelete }}”
      </p>
      <p class="text">Este código vence en</p>
      <span class="text">00:0{{ formatCounter(counter) }}</span>
      <span class="counter">seg</span>
    </div>
    <div class="sendCode">
      <a @click="handleClickResendEmail">Reenviar código de verificación</a>
    </div>
    <a-form class="form" ref="formRef" layout="vertical" :model="formState" :rules="rules">
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-item class="form__item" label="Código de verificación" name="code">
            <a-input
              v-model:value="formState.code"
              placeholder="Ingresar código de verificación"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="button__disabled">
      <a-row :gutter="24">
        <a-col span="4">
          <a-button class="footer__delete" @click="handleBackModal"> Volver </a-button>
        </a-col>
        <a-col span="20">
          <a-button
            style="width: 100%"
            class="footer__delete"
            type="primary"
            @click="handleDeleteEntity"
            :loading="loading"
            :disabled="isDisabled"
          >
            Eliminar empresa
          </a-button>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";
// import { deleteEntity } from "@/app/entities/services";

export default defineComponent({
  name: "InactiveUserModal",
  components: {},
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    emailToDelete: {
      type: String,
      default: "",
    },
  },
  setup() {
    const formRef = ref();
    const initialCounterValue = 120;
    const counter = ref(initialCounterValue);
    const bodyStyle = {
      height: "620px",
      padding: "30px 37px 37px",
      loading: false,
    };
    const formState = reactive({
      code: "",
    });
    const rules = {
      code: [{ required: true, message: "Campo requerido" }],
    };
    const formatCounter = (s) => {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    };
    const sendTime = () => {
      const timer = setInterval(() => {
        counter.value = counter.value - 1;
        if (counter.value === 0) {
          clearInterval(timer);
        }
      }, 1000);
    };
    sendTime();

    return {
      bodyStyle,
      rules,
      formState,
      formRef,
      initialCounterValue,
      counter,
      formatCounter,
    };
  },
  data() {
    return {
      UserStatus,
      loading: false,
    };
  },
  computed: {
    isDisabled() {
      return this.formState.code == "";
    },
  },
  methods: {
    async handleClickResendEmail() {
      try {
        const data = {
          email: this.emailToDelete,
          entity: this.record.id,
        };
        await this.$store.dispatch("sendEntityToken", data);
        this.$message.success("Código enviado");
        this.counter = this.initialCounterValue;
      } catch (error) {
        this.$message.error("Error al enviar el código");
      }
    },
    handleDeleteEntity() {
      this.formRef.validateFields().then(async () => {
        try {
          this.loading = true;
          await this.$store.dispatch("deleteEntity", {
            entityId: this.record.id,
            tokenId: this.formState.code,
          });
          this.loading = false;
          this.$emit("onCloseModal");
          this.$emit("update");
          this.$message.success(`Se eliminó la empresa “${this.record.name}” correctamente`);
        } catch (error) {
          this.loading = false;
          const errorMessage = error?.data?.detail || "Código invalido o el código expiro";
          this.$message.error(errorMessage);
        }
      });
    },
    handleBackModal() {
      this.$emit("onBackModal");
    },
    handleCloseModalHeader() {
      this.$emit("onCloseModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin-bottom: 0
  color: $gray-13

.text
  margin-bottom: 0

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
  margin-top: 30px

.container__info
  margin-bottom: 18px
  text-align: center
  margin-top: 20px
  color: $gray-8

.sendCode
  text-align: center
  margin-bottom: 30px

.counter
  margin-left: 5px
</style>
